import React from 'react';
import { Image, Space } from 'antd';

interface IProps {
  image: string | null;
}

const ViewBuyerPhoto: React.FC<IProps> = ({ image }: IProps) => {
  if (image) {
    return (
      <Image.PreviewGroup>
        <Space size={[8, 16]} wrap>
          <Image height={100} src={image} />
        </Space>
      </Image.PreviewGroup>
    );
  } else {
    return <></>;
  }
};

export default ViewBuyerPhoto;
